import { render, staticRenderFns } from "./PreorderServiceReg.vue?vue&type=template&id=bcaf4fdc&scoped=true"
import script from "./PreorderServiceReg.vue?vue&type=script&lang=js"
export * from "./PreorderServiceReg.vue?vue&type=script&lang=js"
import style0 from "./PreorderServiceReg.vue?vue&type=style&index=0&id=bcaf4fdc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaf4fdc",
  null
  
)

export default component.exports